import type { IconProps } from '@/types/general'

export const Done = (props: IconProps) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="25"
		height="26"
		viewBox="0 0 25 26"
		fill="currentColor"
		className={props.className}
	>
		<path
			d="M22.6411 5.18319C22.4382 5.1891 22.2455 5.27374 22.104 5.41919L8.59383 18.9293L2.8962 13.2317C2.82421 13.1567 2.73798 13.0969 2.64257 13.0556C2.54716 13.0144 2.44448 12.9926 2.34054 12.9915C2.2366 12.9905 2.1335 13.0102 2.03727 13.0495C1.94104 13.0887 1.85361 13.1468 1.78012 13.2203C1.70662 13.2938 1.64852 13.3813 1.60923 13.4775C1.56995 13.5737 1.55025 13.6768 1.55131 13.7808C1.55237 13.8847 1.57415 13.9874 1.61539 14.0828C1.65663 14.1782 1.71649 14.2644 1.79146 14.3364L8.04146 20.5864C8.18798 20.7329 8.38667 20.8152 8.59383 20.8152C8.801 20.8152 8.99968 20.7329 9.1462 20.5864L23.2087 6.52392C23.3214 6.41416 23.3984 6.27292 23.4295 6.1187C23.4606 5.96448 23.4444 5.80445 23.3831 5.65957C23.3217 5.5147 23.2181 5.39171 23.0857 5.30671C22.9533 5.22171 22.7983 5.17866 22.6411 5.18319Z"
			fill="currentColor"
		/>
	</svg>
)
